<template>
  <RecepcionTabs />
</template>

<script>
import RecepcionTabs from '@/components/recepcion/RecepcionTabs.vue'

export default {
  name: 'RecepcionMain',
  components: {
    RecepcionTabs
  }
}
</script>
